import { render } from "./ChildDevelopmentChildContainer.vue?vue&type=template&id=6553c65f&scoped=true&ts=true"
import script from "./ChildDevelopmentChildContainer.vue?vue&type=script&lang=ts"
export * from "./ChildDevelopmentChildContainer.vue?vue&type=script&lang=ts"

import "./ChildDevelopmentChildContainer.vue?vue&type=style&index=0&id=6553c65f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6553c65f"]])

export default __exports__